/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types'

export const cashinAllowanceType = {
  cashedInAmount: PropTypes.shape({
    cents: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  potentialAllowance: PropTypes.shape({
    cents: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  lifecycleOffMldInvIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  lifecycleOffMldPmtInvIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasCashedInPreviously: PropTypes.bool.isRequired,
  hasEligibleInvoices: PropTypes.bool.isRequired,
}

export const customerType = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  previouslySelectedAt: PropTypes.string,
  averageInvoiceSize: PropTypes.shape({
    cents: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  customerRating: PropTypes.shape({
    score: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  pricingBand: PropTypes.shape({
    feeRangeMin: PropTypes.number.isRequired,
    feeRangeMax: PropTypes.number.isRequired,
  }).isRequired,
  accountsReceivable: PropTypes.shape({
    cents: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
}
